/*
 * useScrollTop - this hook is used automatically scroll top the page for user on page change
 */
import { useEffect } from 'react';

const useScrollTop = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
    }, []);
}

export default useScrollTop;